<template>
  <div class="input-group lar_input_group">
    <slot name="first-input" />
    <div
      class="input-group-prepend input-group-append"
    >
      <slot name="middle">
        <span
          class="input-group-text"
        >
          {{ middle }}
        </span>
      </slot>
    </div>
    <slot name="last-input" />
  </div>
</template>
<script>
export default {
  name: 'InputMixGroup',
  props: {
    middle: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.lar_input_group {
  .input-group-text {
    background: #fff;
  }
  .input-group-prepend {
    .input-group-text {
      border-right: 0;
    }
    .form-control {
       border-left: 0;
    }
  }
  .input-group-append {
    .input-group-text {
      border-left: 0;
    }
  }
  .form-control {

    // padding: 0.375rem 1.12rem;
    &:not(first-child) {
      .form-control {
        border-left: 0;
      }
    }

    &:not(textarea) {
    //   height: calc(1.6em + .75rem + 4px);
    height: 39.25px;
    }
  }
}
</style>
